import React from 'react';
import { Stack, Chip } from '@mui/material';

export default function FilterChips({ filters = [] }) {
  if (!filters.length) return null;
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {filters.map((item, idx) => (
        <Chip key={`${item.label}-${idx}`} label={`${item.label}: ${item.value}`} size="small" />
      ))}
    </Stack>
  );
}
